var pug = require("!../../../../../../../node_modules/pug-runtime/index.js");

function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;
;var locals_for_with = (locals || {});(function (artists, counts, s, undefined) {
buf.push("<div class=\"abrv-context__content abrv-context__content--followed-artists\">");
if ( artists && artists.length)
{
// iterate artists
;(function(){
  var $$obj = artists;
  if ('number' == typeof $$obj.length) {

    for (var $index = 0, $$l = $$obj.length; $index < $$l; $index++) {
      var artist = $$obj[$index];

buf.push("<a" + (jade.attr("href", "/artist/" + (artist.id) + "", true, true)) + " class=\"abrv-context__content--followed-artists__artist\">" + (jade.escape(null == (jade_interp = artist.get('name')) ? "" : jade_interp)) + "</a>");
    }

  } else {
    var $$l = 0;
    for (var $index in $$obj) {
      $$l++;      var artist = $$obj[$index];

buf.push("<a" + (jade.attr("href", "/artist/" + (artist.id) + "", true, true)) + " class=\"abrv-context__content--followed-artists__artist\">" + (jade.escape(null == (jade_interp = artist.get('name')) ? "" : jade_interp)) + "</a>");
    }

  }
}).call(this);

if ( counts.artists - artists.length > 0)
{
s = counts.artists - artists.length == 1 ? '' : 's'
buf.push("<a href=\"/works-for-you\" class=\"abrv-context__content--followed-artists__more-artists\">+" + (jade.escape((jade_interp = counts.artists - artists.length) == null ? '' : jade_interp)) + " more artist" + (jade.escape((jade_interp = s) == null ? '' : jade_interp)) + "</a>");
}
}
else
{
buf.push("<p>Follow artists for better recommendations and to receive alerts when new works are available</p><P><span class=\"avant-garde-body\">Or&nbsp;</span><a href=\"/artists\">Browse all artists</a></P>");
}
buf.push("</div>");}.call(this,"artists" in locals_for_with?locals_for_with.artists:typeof artists!=="undefined"?artists:undefined,"counts" in locals_for_with?locals_for_with.counts:typeof counts!=="undefined"?counts:undefined,"s" in locals_for_with?locals_for_with.s:typeof s!=="undefined"?s:undefined,"undefined" in locals_for_with?locals_for_with.undefined:typeof undefined!=="undefined"?undefined:undefined));;return buf.join("");
};
module.exports = template;